<template>
  <v-layout>
    <v-row>
      <v-col cols="12" md="3" xl="2">
        <v-card>
          <v-card-title>
            Filtry
          </v-card-title>
          <v-card-text>
            <SubscriptionFilters/>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" xl="10">
        <v-card>
          <v-card-title>
            Subskrypcje
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <v-btn
                  class="mx-2"
                  @click="refresh"
              >
                Odśwież
              </v-btn>
            </div>
            <data-table
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="total"
                :loading="loading"
                class="row-pointer"
                @click:row="onRowClicked"
            >
              <template v-slot:top>
                <v-dialog v-model="dialogCancel" width="unset">
                  <v-card>
                    <v-card-title class="headline">
                      Czy na pewno chcesz anulować tę subskrypcję?
                    </v-card-title>
                    <v-card-text>
                      ID: {{ editedText }}
                      <p>
                        Spowoduje to również anulowanie wszystkich niezakończonych płatności
                        rozpoczętych w ramach tej subskrypcji.
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="onCancelDialogClosed">
                        Anuluj
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="onCancelConfirmed">
                        Tak
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userId="{ item }">
                <router-link
                    v-if="item.userId"
                    :to="{name: 'user-details', params: {id: item.userId}}"
                >
                  #{{ item.userId }}
                </router-link>
              </template>
              <template v-slot:item.planId="{ item }">
                <router-link
                    v-if="item.planId"
                    :to="{name: 'subscription-plan-details', params: {id: item.planId}}"
                >
                  {{ item.planName }}
                </router-link>
              </template>
              <template v-slot:item.months="{ item }">
                {{ item.months }}
              </template>
              <template v-slot:item.monthsPaidOnce="{ item }">
                {{ item.monthsPaidOnce }}
              </template>
              <template v-slot:item.type="{ item }">
                <span :class="getTypeColor(item.type)">
                  {{ getTypeText(item.type) }}
                </span>
              </template>
              <!--<template v-slot:item.orderId="{ item }">
                <router-link
                    v-if="item.orderId"
                    :to="{name: 'order-details', params: {id: item.orderId}}"
                >
                  #{{ item.orderId }}
                </router-link>
              </template>
              <template v-slot:item.orderStatus="{ item }">
                <span :class="getTransactionStatusColor(item.orderStatus)">
                  {{ getTransactionStatusText(item.orderStatus) }}
                </span>
              </template>-->
              <template v-slot:item.periodFrom="{ item }">
                {{ localDateTime(item.periodFrom, '') }}
              </template>
              <template v-slot:item.periodTo="{ item }">
                {{ localDateTime(item.periodTo, '') }}
              </template>
              <template v-slot:item.periods="{ item }">
                <router-link
                    :to="{name: 'subscription-periods', params: {subscriptionId: item.id}}"
                >
                  Przejdź...
                </router-link>
              </template>
              <template v-slot:item.cancelledAt="{ item }">
                {{ localDateTime(item.cancelledAt, '') }}
                <div v-if="item.cancelledAt && item.cancelledAt.timestamp">
                  Przez:
                  <em v-if="!item.cancelledByUserId">SYSTEM</em>
                  <router-link
                      v-else
                      :to="{name: 'user-details', params: {id: item.cancelledByUserId}}"
                  >
                    #{{ item.cancelledByUserId }}
                  </router-link>
                </div>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ localDateTime(item.createdAt, '') }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ localDateTime(item.updatedAt, '') }}
              </template>
              <template v-slot:item.actions="{ item }"
                        class="text-end"
              >
                <v-icon
                    v-if="!isTransactionFinished(item.status || '')"
                    class="mx-2"
                    :disabled="loading"
                    @click="onCancelBtnTriggered(item, $event)"
                    title="Anuluj."
                >
                  mdi-cancel
                </v-icon>
              </template>
            </data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import api from '@/services/api';
import DataTable from "@/components/data-table/DataTable";
import filters from "@/mixins/filters";
import formatters from "@/mixins/formatters";
import {getDatatableParams, setDatatableOptions} from '@/utils/helpers';
import {
  getTypeColor as getTypeColor,
  getTypeText as getTypeText,
} from "@/enums/SubscriptionType";
import {
  getStatusColor as getTransactionStatusColor,
  getStatusText as getTransactionStatusText,
  isFinished as isTransactionFinished,
} from "@/enums/TransactionStatus";
import SubscriptionFilters from "@/components/subscriptions/SubscriptionFilters";

export default {
  mixins: [
    filters,
    formatters,
  ],
  components: {
    SubscriptionFilters,
    DataTable,
  },
  data() {
    return {
      total: 0,
      items: [],
      initialized: false,
      loading: false,
      options: {},
      headers: [
        {text: 'Użytkownik', value: 'userId', sortable: false},
        {text: 'Plan', value: 'planId', sortable: false},
        {text: 'Miesiące', value: 'months', sortable: false},
        {text: 'Opłacane jednorazowo', value: 'monthsPaidOnce', sortable: false},
        {text: 'Typ', value: 'type', sortable: false},
        {text: 'Okres od', value: 'periodFrom', sortable: false},
        {text: 'Okres do', value: 'periodTo', sortable: false},
        {text: 'Okresy', value: 'periods', sortable: false},
        {text: 'Anulowano', value: 'cancelledAt', sortable: false},
        {text: 'Utworzono', value: 'createdAt', sortable: false},
        {text: 'Ost. aktualizacja', value: 'updatedAt', sortable: false},
        {text: 'Akcje', value: 'actions', sortable: false},
      ],
      filters: {},
      dialogCancel: false,
      editedIndex: -1,
      editedText: '',
      urlCancel: '/api/subscription/{id}',
    }
  },
  created() {
    getDatatableParams.call(this);
    //this.load();
  },
  async mounted() {
    const self = this;

    const store = {
        filters: null,
    };
    await this.$root.$emit('getSubscriptionsFilters', store);
    this.filters = store.filters;
    this.load();

    this.$root.$on('loadSubscriptions', (options) => {
      self.load(options);
    });
  },
  watch: {
    options: {
      handler() {
        if (!this.initialized) {
          return;
        }

        this.load();
        setDatatableOptions.call(this);
      },
      deep: true,
    },
  },
  methods: {
    appendFilters(params, filters) {
      if (!(filters instanceof Object)) {
        return;
      }

      this.appendStringFilterIfNonEmpty(params, 'planId', filters.planId);
      this.appendIntFilterIfNonEmpty(params, 'userId', filters.userId);
      this.appendStringFilterIfNonEmpty(params, 'orderId', filters.orderId, 2);
      this.appendStringFilterIfNonEmpty(params, 'payU_orderId', filters.payU_orderId, 2);
      this.appendStringFilterIfNonEmpty(params, 'periodFrom', filters.periodFrom, 10);
      this.appendStringFilterIfNonEmpty(params, 'periodTo', filters.periodTo, 10);
      this.appendArrayFilterIfNonEmpty(params, 'orderStatuses', filters.orderStatuses);
    },
    cancelItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedText = item.id;
      this.dialogCancel = true;
    },
    formatEmpty(value, onEmptyHtml = 'Brak', onEmptyClasses = 'orange--text') {
      if (null !== value && '' !== value) {
        return value;
      }

      return `<em class="${onEmptyClasses}">${onEmptyHtml}</em>`;
    },
    cancel(index) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      const item = this.items[index];

      api
          .delete(this.urlCancel.replace('{id}', item.id))
          .then((response) => {
            const statuses = this.filters.statuses || [];

            if (statuses.length &&
                !statuses.includes('CANCELED') &&
                !statuses.includes('CANCELLED')
            ) {
              // The table is not displaying such statuses.
              this.items.splice(index, 1);
              this.total--;

              if (!this.items.length) {
                this.items.page--;
              }
            } else {
              item.cancelledAt = response.data.cancelledAt;
              item.cancelledByUserId = response.data.cancelledByUserId;
              item.updatedAt = response.data.updatedAt;
            }

            this.onCancelDialogClosed();

            if (item.cancelledAt && item.cancelledAt.timestamp) {
              this.$root.$emit('notifySuccess', {
                html: `Subskrypcja została anulowana.`,
              });
            } else {
              this.$root.$emit('notifyError', {
                html: `Nie udało się anulować subskrypcji - serwer obsłużył żądanie, ale nie ustawił daty anulowania.`,
              });
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się anulować subskrypcji.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    load(options = {}) {
      if (this.loading) {
        return;
      }

      this.loading = true;
      options = options || {};

      let filters = {};
      this.appendFilters(filters, options.filters || this.filters);
      this.filters = filters; // Remember them.

      const {page, itemsPerPage} = this.options;
      const params = {
        ...filters,
        offset: page > 1 ? itemsPerPage * (page - 1) : 0
      };

      if (-1 !== itemsPerPage) {
        params.limit = itemsPerPage;
      }

      api.get('/api/subscription', {params})
          .then((response) => {
            this.items = response.data.items;
            this.total = response.data.total;

            if (options.onSuccess) {
              options.onSuccess();
            }
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać listy subskrypcji.',
              error,
            });
          })
          .finally(() => {
            this.initialized = true;
            this.loading = false;
          });
    },
    refresh() {
      const self = this;
      this.$root.$emit('loadSubscriptions', {
        onSuccess: () => {
          self.$root.$emit('notify', {
            html: 'Lista subskrypcji odświeżona.',
          });
        }
      });
    },
    stopRowClickPropagation(event) {
      // The following line is required to avoid triggering onRowClicked() method.
      event.cancelBubble = true;
      event.stopPropagation();
    },
    onCancelBtnTriggered(item, event) {
      this.stopRowClickPropagation(event);
      this.cancelItem(item);
    },
    onCancelConfirmed() {
      this.cancel(this.editedIndex);
    },
    onCancelDialogClosed() {
      this.dialogCancel = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.editedText = '';
      });
    },
    onRowClicked(item) {
      this.$router
          .push({name: 'subscription-details', params: {id: item.id}})
          .catch(() => {
          })
    },
    getTypeColor(status) {
      return getTypeColor(status);
    },
    getTypeText(status) {
      return getTypeText(status);
    },
    getTransactionStatusColor(status) {
      return getTransactionStatusColor(status);
    },
    getTransactionStatusText(status) {
      return getTransactionStatusText(status);
    },
    isTransactionFinished(status) {
      return isTransactionFinished(status);
    },
  },
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>